package one.healthium.profile.navigation.log_weight

import com.arkivanov.decompose.ComponentContext

class DefaultLogWeightComponent(
    componentContext: ComponentContext,
    override val taskId: String?,
    private val onCloseClicked: () -> Unit,
) : LogWeightComponent, ComponentContext by componentContext {
    override fun onCloseClicked() {
        onCloseClicked.invoke()
    }
}